module.exports = __webpack_public_path__ + "img/510kClearance.8dc49ad9.png";